import React from 'react';
import { useEffect, useState } from 'react';
import Swp from '../../../lib/component/swp/swp';
import Loading from '../../../lib/component/loading1/loading';
import Card1 from './card1/card';
import Illustrations from './illustrations/illustrations';

import selectionApi from '../js/selectionApi';
import { Section } from '../js/interface';
import statisticsApi from '../../../lib/statisticsApi';

export default ({ fnArr }: { fnArr: (Function | null)[] }) => {
  const [info, setInfo] = useState<Section[]>([]);
  const strSwpArr = ['bookListDetails', 'bookListDetails', 'bookListDetails', 'bookListDetails'];
  useEffect(() => {
    selectionApi.getHomeApi(
      (res: any) => {
        setInfo(res.sections);
      },
      () => {}
    );
    statisticsApi.statisticsApi(2);
  }, []);

  function page() {
    if (info.length) {
      return info.map((item, index) => {
        if (index === 0) {
          return <Swp {...{ bdArr: item.boutique_data, strSwpArr: strSwpArr, tip: 'selection' }} key={index}></Swp>;
        } else if (index > 0 && index < info.length - 1) {
          return <Card1 {...{ title: item.category?.name, bookArr: item.boutique_data, button: '', fn: fnArr[index - 1] }} key={index}></Card1>;
        } else if (index === info.length - 1) {
          return <Illustrations {...{ title: item.category?.name, bdArr: item.boutique_data }} key={index}></Illustrations>;
        }
      });
    } else {
      return <Loading></Loading>;
    }
  }

  return <>{page()}</>;
};
